import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'inspections'),
  uk: createLocale(uk, 'inspections'),
  pl: createLocale(pl, 'inspections'),
  ru: createLocale(ru, 'inspections'),
  es: createLocale(es, 'inspections'),
  uz: createLocale(uz, 'inspections'),
  hi: createLocale(hi, 'inspections'),
};

export default locales;
